import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  TextField,
  Tooltip,
} from "@mui/material";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Xarrow from "react-xarrows";
import * as yup from "yup";
import { DeleteOnIcon } from "../../../../assets/icons/CustomIcons";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import useDidMountEffect from "../../../../common/components/Custom Hooks/useDidMountEffect";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import DatePickerFieldNew from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import LoadingSpinner from "../../../../common/components/loadingspinner/loadingSpinner";
import {
  deleteAlert,
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import {
  deleteHumanBody,
  getAllHumanBodyList,
  getBodyEquipmentList,
  saveHumanBody,
} from "../../../services/cliinicalChartServices/humanbodyServices/HumanBodyServices";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import HealingIcon from "@mui/icons-material/Healing";
import BedSoreAuditModel from "./BedSoreAuditModel";
import LinesModel from "./LinesModel";

const CheckBoxInput = ({
  label,
  control,
  stateChecked,
  setBodyInput,
  name,
  disabled,
  dataResult,
  props,
}) => {
  console.log("labeel", label, stateChecked);
  return (
    <FormControl>
      <Controller
        render={({ field }) => (
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                checked={stateChecked}
                defaultChecked={stateChecked}
                onChange={(e) => {
                  let value = e.target.checked;
                  let obj = {
                    inputType: label,
                    inputKey: name,
                    applied: value,
                  };
                  setBodyInput(obj);
                  console.log("obj", obj);
                  let lastRHIntracathId = null;

                  dataResult?.forEach((obj) => {
                    if (obj["Mode"] === label) {
                      lastRHIntracathId = obj.Id;
                    }
                  });
                }}
                disabled={
                  !props.selectedPatient?.AllowToGO
                    ? false
                    : props.selectedPatient?.AllowToGO && !stateChecked
                      ? true
                      : false || disabled
                }
              />
            }
            {...field}
            type="checkbox"
            sx={{
              "& .MuiSvgIcon-root": { fontSize: 20 },
            }}
            className="w-full items-center pl-20 md:pl-0 text-gray-800 font-bold tracking-wider mr-2"
          />
        )}
        name={name}
        control={control}
        defaultValue={stateChecked}
      />
    </FormControl>
  );
};

export default function HumanBody(props, { drawerOpen }) {
  const schema = yup
    .object()
    .shape({
      doneBy: yup
        .string()
        .required("Required")
        .min(1, "Add Gender Code")
        .matches(
          /^[a-zA-Z0-9.\s]+$/,
          "Only letters, numbers, spaces, and dots are allowed"
        ),
    })
    .required();

  console.log("HumanBodyProps", props);

  let getpatientVisitId = props.displayInfo?.AdmissionId;
  let getUserId = JSON.parse(localStorage.getItem("userInfo"));

  const [finalVisitId, setFinalVisitId] = useState(null);
  const [spinner, showSpinner] = useState(false);

  const defaultValues = {
    CVP: false,
    ETT: false,
    RT: false,
    rhIntracath: false,
    lhIntracath: false,
    cathater: false,
    rlIntracath: false,
    llIntracath: false,
    doneBy: getUserId?.userName?.split(".")?.[1],
    remarks: "",
    date: new Date(),
    time: new Date(),
    outSide: false,
    doneByOutSide: getUserId?.userName,
  };

  const [dataResult, setDataResult] = useState([]);
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
    control,
    setValue,
    watch,
    getValues,
  } = methods;

  const [CVP, setCVP] = useState(false);
  const [ETT, setETT] = useState(false);
  const [RT, setRT] = useState(false);
  const [rhIntracath, setrhIntracath] = useState(false);
  const [lhIntracath, setlhIntracath] = useState(false);
  const [cathater, setcathater] = useState(false);
  const [rlIntracath, setrlIntracath] = useState(false);
  const [llIntracath, setllIntracath] = useState(false);
  const [drain, setDrain] = useState(false);
  const [icd, setICD] = useState(false);
  const [hdActh, setHdActh] = useState(false);
  const [cvpFemora, setCvpFemora] = useState(false);
  const [cvpUmbilical, setCvpUmbilical] = useState(false);
  const [plccLinne, setPlccLine] = useState(false);
  const [thracheostomy, setThracheostomy] = useState(false);
  const [permacath, setPermacath] = useState(false);
  const [chemoPort, setChemoPort] = useState(false);
  const [arterialLine, setArterialLine] = useState(false);
  const [jejunostomy, setJejunostomy] = useState(false);
  const [epidural, setEpidural] = useState(false);
  const [getEquipmentList, setGetEquipmentList] = useState([]);
  const [modeId, setModeId] = useState(null);
  const [applyChecked, setApplyChecked] = useState();
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState(new Date());
  const [showArrows, setShowArrows] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [deleteObj, setDeleteObj] = useState(null);
  const [deleteconfirm, setDeleteconfirm] = useState(false);
  const handleOpenDeleteConfirm = () => setDeleteconfirm(true);
  const handleCloseDeleteConfirm = () => setDeleteconfirm(false);

  const [bodyInput, setBodyInput] = useState({
    inputType: "",
    inputKey: "",
    applied: false,
    id: null,
  });

  const [open, setOpen] = useState(false);
  // Nurse, Doctor, and Rmo

  const handleOpen = () => {
    if (finalVisitId) {
      // let getUserInfo = JSON.parse(localStorage.getItem("userInfo"));
      // let getEmpCategoryId = getUserInfo.empCategoryId;
      // if (getEmpCategoryId === 1) {
      setOpen(true);
      //   }
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const fnReset = () => {
    reset();
    setValue("doneBy", "");
    setDate(new Date());
    setTime(new Date());
  };

  const CallBodyDetails = (obj) => {
    showSpinner(true);
    getAllHumanBodyList(props.displayInfo?.AdmissionId || props?.admissionId)
      .then((response) => response.data)
      .then((res) => {
        showSpinner(false);
        setBodyDetails(res.result?.humanBodyStatus);
        setDataResult(res.result?.humanBodyList);
      });
  };

  const setBodyDetails = (bodyData) => {
    setApplyChecked(bodyData);

    if (bodyData) {
      setValue(
        "outSide",
        bodyInput.inputType === "Central Venous Pressure (CVP)"
          ? bodyData.isCvpOutSide
          : bodyInput.inputType === "Endotracheal Tube (ETT)" //"ENDOTRACHEAL TUBE (ETT)"
            ? bodyData.isEttOutSide
            : bodyInput.inputType === "RT"
              ? bodyData.isRt
              : bodyInput.inputType === "lhIntracath"
                ? bodyData.isLhIntracathOutSide
                : bodyInput.inputType === "rhIntracath"
                  ? bodyData.isRhIntracathOutSide
                  : bodyInput.inputType === "rlIntracath"
                    ? bodyData.isRlIntracathOutSide
                    : bodyInput.inputType === "llIntracath"
                      ? bodyData.isLlIntracathOutSide
                      : bodyInput.inputType === "Foleys Cathater" //Foleys Cathater
                        ? bodyData.isFoleysCathaterOutSide
                        : bodyInput.inputType === "Drain"
                          ? bodyData.isDrainOutSide
                          : bodyInput.inputType === "ICD"
                            ? bodyData.isICDOutSide
                            : bodyInput.inputType === "Epidural"
                              ? bodyData.isEpiduralOutSide
                              : bodyInput.inputType === "HD Cath" //acth
                                ? bodyData.isHDacthOutSide
                                : bodyInput.inputType === "CVP Femoral"
                                  ? bodyData.isCVPFemoralOutSide
                                  : bodyInput.inputType === "CVP Umbilical"
                                    ? bodyData.isCVPUmbilicalOutSide
                                    : bodyInput.inputType === "PICC Line"
                                      ? bodyData.isPICCLineOutSide
                                      : bodyInput.inputType === "Tracheostomy"
                                        ? bodyData.isTracheostomyOutSide
                                        : bodyInput.inputType === "Perma Cath" //"PermaCath"
                                          ? bodyData.isPermacathOutSide
                                          : bodyInput.inputType === "Chemo Port"
                                            ? bodyData.isChemoPortOutSide
                                            : bodyInput.inputType === "Arterial Lines"
                                              ? bodyData.isArterialLinesOutSide
                                              : bodyInput.inputType === "Jejunostomy"
                                                ? bodyData.isJejunostomyOutSide
                                                : false
      );
      setCVP(bodyData.isCvp);
      setETT(bodyData.isEtt);
      setRT(bodyData.isRt);
      setrhIntracath(bodyData.isRhIntracath);
      setlhIntracath(bodyData.isLhIntracath);
      setcathater(bodyData.isFoleysCathater);
      setrlIntracath(bodyData.isRlIntracath);
      setllIntracath(bodyData.isLlIntracath);
      setDrain(bodyData.isDrain);
      setICD(bodyData.isICD);
      setHdActh(bodyData.isHDacth);
      setCvpFemora(bodyData.isCVPFemoral);
      setCvpUmbilical(bodyData.isCVPUmbilical);
      setPlccLine(bodyData.isPICCLine);
      setThracheostomy(bodyData.isTracheostomy);
      setPermacath(bodyData.isPermacath);
      setChemoPort(bodyData.isChemoPort);
      setArterialLine(bodyData.isArterialLines);
      setJejunostomy(bodyData.isJejunostomy);
      setEpidural(bodyData.isEpidural);
      // setDrain(bodyData.drain);
    } else {
      setCVP(false);
      setETT(false);
      setRT(false);
      setrhIntracath(false);
      setlhIntracath(false);
      setcathater(false);
      setrlIntracath(false);
      setllIntracath(false);
      setDrain(false);
      setICD(false);
      setHdActh(false);
      setEpidural(false);
      setCvpFemora(false);
      setCvpUmbilical(false);
      setPlccLine(false);
      setThracheostomy(false);
      setPermacath(false);
      setChemoPort(false);
      setArterialLine(false);
      setJejunostomy(false);
      // // // setDrain(false);
    }
  };

  const populateTable = (input) => { };

  let doneBy = watch("doneBy");
  let outSide = watch("outSide");

  const onSubmit = (data) => {
    let insertRemark;
    let insertedBy;

    let removeRemark;
    let removedBy;

    if (bodyInput.applied === true) {
      insertRemark = data.remarks;
      insertedBy = doneBy;
    }

    if (bodyInput.applied === false) {
      removeRemark = data.remarks;
      removedBy = doneBy;
    }

    let obj = {
      menuId: props?.menuId,
      privilege: props.privilege,
      addedBy: getUserId.userId,
      admissionId: getpatientVisitId || props?.admissionId,
      date: format(date ? date : new Date(), "yyyy-MM-dd'T'hh:mm:ss.000'Z'"),
      insertRemark: insertRemark,
      insertedBy: insertedBy,
      isOutSide: outSide,
      removeRemark: removeRemark,
      removedBy: removedBy,
      time: format(time ? time : new Date(), "yyyy-MM-dd'T'HH:mm:ss.000'Z'"),
      modeId: modeId,
    };
    console.log("bodyInput.inputKey", bodyInput.inputKey);

    if (bodyInput.inputKey === "Central Venous Pressure (CVP)") {
      obj.mode = "Central Venous Pressure (CVP)";
      setCVP(bodyInput.applied);
    } else if (bodyInput.inputKey === "Endotracheal Tube (ETT)") {
      obj.mode = "Endotracheal Tube (ETT)";
      setETT(bodyInput.applied);
    } else if (bodyInput.inputKey === "RT") {
      obj.mode = "RT";
      setRT(bodyInput.applied);
    } else if (bodyInput.inputKey === "Foleys Cathater") {
      obj.mode = "Foleys Cathater";
      setcathater(bodyInput.applied);
    } else if (bodyInput.inputKey === "Drain") {
      obj.mode = "Drain";
      setDrain(bodyInput.applied);
    } else if (bodyInput.inputKey === "ICD") {
      obj.mode = "ICD";
      setICD(bodyInput.applied);
    } else if (bodyInput.inputKey === "HD Cath") {
      obj.mode = "HD Cath";
      setHdActh(bodyInput.applied);
    } else if (bodyInput.inputKey === "CVP Femoral") {
      obj.mode = "CVP Femoral";
      setCvpFemora(bodyInput.applied);
    } else if (bodyInput.inputKey === "CVP Umbilical") {
      obj.mode = "CVP Umbilical";
      setCvpUmbilical(bodyInput.applied);
    } else if (bodyInput.inputKey === "PICC Line") {
      obj.mode = "PICC Line";
      setPlccLine(bodyInput.applied);
    } else if (bodyInput.inputKey === "Tracheostomy") {
      obj.mode = "Tracheostomy";
      setThracheostomy(bodyInput.applied);
    } else if (bodyInput.inputKey === "Perma Cath") {
      obj.mode = "Perma Cath";
      setPermacath(bodyInput.applied);
    } else if (bodyInput.inputKey === "Chemo Port") {
      obj.mode = "Chemo Port";
      setChemoPort(bodyInput.applied);
    } else if (bodyInput.inputKey === "Arterial Lines") {
      obj.mode = "Arterial Lines";
      setArterialLine(bodyInput.applied);
    } else if (bodyInput.inputKey === "Jejunostomy") {
      obj.mode = "Jejunostomy";
      setJejunostomy(bodyInput.applied);
    } else if (bodyInput.inputKey === "Epidural") {
      obj.mode = "Epidural";
      setEpidural(bodyInput.applied);
    } else if (
      bodyInput.inputKey === "rhIntracath" ||
      bodyInput.inputKey === "lhIntracath" ||
      bodyInput.inputKey === "rlIntracath" ||
      bodyInput.inputKey === "llIntracath"
    ) {
      obj.mode = "Intracath";
    }

    if (bodyInput.inputKey === "rhIntracath") {
      obj.modePosition = "R.H.Intracath";
      setrhIntracath(bodyInput.applied);
    } else if (bodyInput.inputKey === "lhIntracath") {
      obj.modePosition = "L.H.Intracath";
      setlhIntracath(bodyInput.applied);
    } else if (bodyInput.inputKey === "rlIntracath") {
      obj.modePosition = "R.L.Intracath";
      setrlIntracath(bodyInput.applied);
    } else if (bodyInput.inputKey === "llIntracath") {
      obj.modePosition = "L.L.Intracath";
      setllIntracath(bodyInput.applied);
    }
    saveApi(obj);

    setOpenBackdrop(true);
    handleClose();
    fnReset();
  };

  function saveApi(finalObj) {
    saveHumanBody(finalObj)
      .then((response) => {
        setOpenBackdrop(false);
        successAlert(response.data.message);
        CallBodyDetails(props.displayInfo?.AdmissionId || props.admissionId);
      })
      .catch((error) => {
        setOpenBackdrop(false);
        errorAlert(error.response.data.message || error.message);
      });
  }

  function deleteRecord() {
    if (deleteObj) {
      setOpenBackdrop(true);

      deleteHumanBody(deleteObj.Id, props?.menuId, deleteObj.action)
        .then((response) => {
          if (response.data.statusCode === 200) {
            deleteAlert(response.data.message);
            setOpenBackdrop(false);
            handleCloseDeleteConfirm();
            CallBodyDetails();
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          handleCloseDeleteConfirm();
        });
    }
  }

  const renderActions = (row, index) => {
    return (
      <div className="flex gap-3">
        {props.userActions.map((obj) => (
          <>
            {obj.isAction === true &&
              obj.action === "Delete" &&
              !props.selectedPatient?.AllowToGO ? (
              <>
                <DeleteOnIcon
                  title="Delete"
                  onClick={() => {
                    let deleteObjVal = {};

                    deleteObjVal.Id = row.Id;

                    deleteObjVal.action = obj.action;

                    setDeleteObj(deleteObjVal);

                    //open the delete confirmation modal
                    handleOpenDeleteConfirm();
                  }}
                />
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  useEffect(() => {
    let id = null;
    if (getpatientVisitId) {
      id = getpatientVisitId;
    } else if (props.admissionId) {
      id = props.admissionId;
    }
    setFinalVisitId(id);
  }, []);

  const [positions, setPositions] = useState({
    CVPBOX: { cx: 100, cy: 70 },
    ETTBOX: { cx: 125, cy: 40 },
    RTBOX: { cx: 125, cy: 60 },
    rhIntracathBOX: { cx: 8, cy: 240 },
    lhIntracathBOX: { cx: 245, cy: 245 },
    cathaterBOX: { cx: 130, cy: 260 },
    rlIntracathBOX: { cx: 80, cy: 480 },
    llIntracathBOX: { cx: 165, cy: 475 },
  });

  const flagMap = {
    CVPBOX: CVP,
    ETTBOX: ETT,
    RTBOX: RT,
    rhIntracathBOX: rhIntracath,
    lhIntracathBOX: lhIntracath,
    cathaterBOX: cathater,
    rlIntracathBOX: rlIntracath,
    llIntracathBOX: llIntracath,
  };

  useEffect(() => {
    const updatePositions = () => {
      const isLargeScreen = window.innerWidth > 1535;
      const offset = isLargeScreen ? -20 : 0;
      console.log("window.innerWidth", isLargeScreen, offset);
      if (isLargeScreen) {
        setPositions({
          CVPBOX: { cx: 120 + offset, cy: 95 + offset },
          ETTBOX: { cx: 150 + offset, cy: 60 + offset },
          RTBOX: { cx: 150 + offset, cy: 80 + offset },
          rhIntracathBOX: { cx: 18 + offset, cy: 280 + offset },
          lhIntracathBOX: { cx: 270 + offset, cy: 285 + offset },
          cathaterBOX: { cx: 145 + offset, cy: 290 + offset },
          rlIntracathBOX: { cx: 100 + offset, cy: 500 + offset },
          llIntracathBOX: { cx: 185 + offset, cy: 495 + offset },
        });
      }
    };

    updatePositions();
    window.addEventListener("resize", updatePositions);
    return () => window.removeEventListener("resize", updatePositions);
  }, []);

  useEffect(() => {
    // if (finalVisitId !== null) {
    CallBodyDetails();
    // }
  }, [props.displayInfo?.AdmissionId, props?.admissionId, bodyInput]);

  useEffect(() => {
    getBodyEquipmentList()
      .then((response) => response.data)
      .then((res) => {
        setGetEquipmentList(res.result);
      });
  }, [getpatientVisitId]);

  // bodyInput
  useDidMountEffect(() => {
    reset();

    if (bodyInput?.inputKey !== "Intracath") {
      handleOpen();
    }
  }, [bodyInput]);

  useEffect(() => {
    if (!drawerOpen) {
      setShowArrows(false);
      setTimeout(() => {
        setShowArrows(true);
      }, [250]);
    } else {
      setShowArrows(false);
      setTimeout(() => {
        setShowArrows(true);
      }, [250]);
    }
  }, [drawerOpen]);
  useEffect(() => {
    if (props.displayInfo?.AdmissionId || props.admissionId) {
      reset(defaultValues);

      // setShowArrows(false);
      setCVP(false);
      setETT(false);
      setRT(false);
      setDrain(false);
      setICD(false);
      setHdActh(false);
      setCvpFemora(false);
      setCvpUmbilical(false);
      setPlccLine(false);
      setThracheostomy(false);
      setPermacath(false);
      setChemoPort(false);
      setArterialLine(false);
      setJejunostomy(false);
      setrhIntracath(false);
      setlhIntracath(false);
      setcathater(false);
      setrlIntracath(false);
      setllIntracath(false);
      // setDrain(false);
    }
  }, [props.displayInfo?.AdmissionId, props.admissionId]);
  const [modalType, setModalType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  function handleOpenModal(row) {
    console.log("handleOpenModalhandleOpenModal", row);
    setSelectedEquipment(row)
    if (row?.["Equipment Name"] === "Bed Sore") {
      setModalType("bedSore")
    } else {
      setModalType("equipment")
    }
    setOpenModal(true)
  }
  const handleCloseModal = () => {
  setOpenModal(false);
  setModalType("");
};
  return (
    <>
      <div className="ml-4 font-semibold text-sm my-2">Human Body</div>
      {/* <fieldset disabled={props.selectedPatient?.AllowToGO ? true : false}> */}
      <div className="bg-white relative ">
        <Grid
          container
          spacing={1}
          sx={{
            position: "relative",
            paddingX: "0.2rem",
            paddingLeft: "1rem",
          }}
        >
          <Grid
            item
            lg={3}
            md={3}
            sx={{
              paddingLeft: "1rem",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {getEquipmentList?.map((row, index) => (
              <tr className=" flex space-x-2">
                {/* CVP */}
                <td className="flex items-center space-x-16">
                  <fieldset
                    onChange={(e) => {
                      setModeId(row.id);
                    }}
                  >
                    <CheckBoxInput
                      control={control}
                      // defaultValue={row?.["Equipment Name"]}
                      name={row?.["Equipment Name"]}
                      label={row?.["Equipment Name"]}
                      stateChecked={
                        row?.["Equipment Name"] ===
                          "Central Venous Pressure (CVP)" &&
                          applyChecked?.isCvp === true
                          ? true
                          : row?.["Equipment Name"] ===
                            "Endotracheal Tube (ETT)" &&
                            applyChecked?.isEtt === true
                            ? true
                            : row?.["Equipment Name"] === "RT" &&
                              applyChecked?.isRt === true
                              ? true
                              : row?.["Equipment Name"] === "Intracath" &&
                                applyChecked?.isLhIntracath === true
                                ? true
                                : row?.["Equipment Name"] === "Intracath" &&
                                  applyChecked?.isRhIntracath === true
                                  ? true
                                  : row?.["Equipment Name"] === "Intracath" &&
                                    applyChecked?.isLlIntracath === true
                                    ? true
                                    : row?.["Equipment Name"] === "Intracath" &&
                                      applyChecked?.isRlIntracath === true
                                      ? true
                                      : row?.["Equipment Name"] === "Foleys Cathater" &&
                                        applyChecked?.isFoleysCathater === true
                                        ? true
                                        : row?.["Equipment Name"] === "Drain" &&
                                          applyChecked?.isDrain === true
                                          ? true
                                          : row?.["Equipment Name"] === "ICD" &&
                                            applyChecked?.isICD === true
                                            ? true
                                            : row?.["Equipment Name"] === "Epidural" &&
                                              applyChecked?.isEpidural === true
                                              ? true
                                              : row?.["Equipment Name"] === "HD Cath" &&
                                                applyChecked?.isHDacth === true
                                                ? true
                                                : row?.["Equipment Name"] === "CVP Femoral" &&
                                                  applyChecked?.isCVPFemoral === true
                                                  ? true
                                                  : row?.["Equipment Name"] === "CVP Umbilical" &&
                                                    applyChecked?.isCVPUmbilical === true
                                                    ? true
                                                    : row?.["Equipment Name"] === "PICC Line" &&
                                                      applyChecked?.isPICCLine === true
                                                      ? true
                                                      : row?.["Equipment Name"] === "Tracheostomy" &&
                                                        applyChecked?.isTracheostomy === true
                                                        ? true
                                                        : row?.["Equipment Name"] === "Perma Cath" &&
                                                          applyChecked?.isPermacath === true
                                                          ? true
                                                          : row?.["Equipment Name"] === "Chemo Port" &&
                                                            applyChecked?.isChemoPort === true
                                                            ? true
                                                            : row?.["Equipment Name"] === "Arterial Lines" &&
                                                              applyChecked?.isArterialLines === true
                                                              ? true
                                                              : row?.["Equipment Name"] === "Jejunostomy" &&
                                                                applyChecked?.isJejunostomy === true
                                                                ? true
                                                                : false
                      }
                      setBodyInput={setBodyInput}
                      props={props}
                    />
                  <IconButton
  size="small"
  onClick={() => handleOpenModal(row)}
  sx={{
    padding: "2px",
    marginTop: "-2px",
    color:
      row?.["Equipment Name"] === "Bed Sore"
        ? "#E53935"
        : "#01C99C",

    background:
      row?.["Equipment Name"] === "Bed Sore"
        ? "#FFE5E5"
        : "#EFFFFA",

    borderRadius: "6px",

    "&:hover": {
      background:
        row?.["Equipment Name"] === "Bed Sore"
          ? "#FFD6D6"
          : "#D9FFF3",
    },
  }}
>
  {row?.["Equipment Name"] === "Bed Sore" ? (
   <Tooltip title={"Bed Sore"}> <HealingIcon fontSize="small" /></Tooltip>
  ) : (
   <Tooltip title={"Lines"}> <MedicalInformationIcon fontSize="small" /></Tooltip>
  )}
</IconButton>
                  </fieldset>
                  <div>
                    <div className="flex gap-2">
                      {row?.["Left Side"] ? (
                        <fieldset
                          onClick={(e) => {
                            setBodyInput({
                              inputType: "lhIntracath",
                              inputKey: "lhIntracath",
                              applied:
                                applyChecked?.isLhIntracath === false
                                  ? true
                                  : false,
                            });
                            setModeId(row.id);
                          }}
                        >
                          <button
                            type="button"
                            className={` 
            
            rounded-full w-[20px] border ${applyChecked?.isLhIntracath === true
                                ? "bg-[#01C99C] text-white"
                                : ""
                              } 
            
            border-[#01C99C] border-[1px] w-[25px] mt-2 rounded-full h-[25px] text-[11px] text-center pt-[1px] gap-2 font-semibold
            
            `}
                            name="side"
                          >
                            LH
                          </button>
                        </fieldset>
                      ) : null}
                      {row?.["Right Side"] ? (
                        <fieldset
                          onClick={() => {
                            setBodyInput({
                              inputType: "rhIntracath",
                              inputKey: "rhIntracath",
                              applied:
                                applyChecked?.isRhIntracath === false
                                  ? true
                                  : false,
                            });
                            setModeId(row.id);
                          }}
                        >
                          <button
                            type="button"
                            className={` rounded-full w-[20px] border ${applyChecked?.isRhIntracath === true
                                ? "bg-[#01C99C] text-white"
                                : ""
                              } 
            border-[#01C99C] border-[1px] w-[25px] mt-2 rounded-full h-[25px] text-[11px] text-center pt-[1px] gap-2 font-semibold
            
            `}
                            name="side"
                          >
                            RH
                          </button>
                        </fieldset>
                      ) : null}
                    </div>
                    <div className="flex gap-2">
                      {row?.["Left Side"] ? (
                        <fieldset
                          onClick={() => {
                            setBodyInput({
                              inputType: "llIntracath",
                              inputKey: "llIntracath",
                              applied:
                                applyChecked?.isLlIntracath === false
                                  ? true
                                  : false,
                            });
                            setModeId(row.id);
                          }}
                        >
                          <button
                            type="button"
                            className={` rounded-full w-[20px] border ${applyChecked?.isLlIntracath === true
                                ? "bg-[#01C99C] text-white"
                                : ""
                              } 
            border-[#01C99C] border-[1px] w-[25px] mt-2 rounded-full h-[25px] text-[11px] text-center pt-[1px] gap-2 font-semibold
            
            `}
                            // className="border-[#01C99C] border-[1px] w-[20px] mt-2 rounded-full h-[20px] text-[11px] text-center pt-[1px] gap-2 font-semibold"
                            name="side"
                          >
                            LL
                          </button>
                        </fieldset>
                      ) : null}
                      {row?.["Right Side"] ? (
                        <fieldset
                          onClick={() => {
                            setBodyInput({
                              inputType: "rlIntracath",
                              inputKey: "rlIntracath",
                              applied:
                                applyChecked?.isRlIntracath === false
                                  ? true
                                  : false,
                            });
                            setModeId(row.id);
                          }}
                        >
                          <button
                            type="button"
                            className={` rounded-full w-[20px] border ${applyChecked?.isRlIntracath === true
                                ? "bg-[#01C99C] text-white"
                                : ""
                              } 
            border-[#01C99C] border-[1px] w-[25px] mt-2 rounded-full h-[25px] text-[11px] text-center pt-[1px] gap-2 font-semibold
            
            `}
                            // className="border-[#DA7200] border-[1px] w-[20px] mt-2 rounded-full h-[20px] text-[11px] text-center pt-[1px] gap-2 font-semibold"
                            name="side"
                          >
                            RL
                          </button>
                        </fieldset>
                      ) : null}
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </Grid>
          <Grid
            item
            lg={9}
            md={9}
            sx={{ paddingX: "1rem", position: "relative" }}
          >
            <svg
              className="mx-auto z-0 "
              width="246"
              height="519"
              viewBox="0 0 246 519"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Human Body"
                d="M145.08 66.1403C156.025 43.2269 155.099 20.4455 149.607 12.452C144.702 5.31167 134.147 -0.144149 122.797 0.00312457C111.446 -0.144149 101.298 5.31167 96.3928 12.452C90.9015 20.4455 89.9746 43.2269 100.92 66.1403C101.111 66.5411 101.176 66.9976 101.053 67.4244C98.8727 74.9914 86.3648 83.6106 62.6115 86.1179C51.7085 87.3725 28.9374 96.0117 25.0767 120.531C20.259 151.129 -7.55012 254.263 1.97103 280.634C2.0051 280.729 2.02561 280.808 2.05392 280.904C3.59885 286.158 32.9412 300.26 29.4957 291.296C29.4208 291.102 29.2973 290.907 29.1591 290.751C20.2165 280.628 11.0201 263.774 35.422 278.593C35.9796 278.932 36.6961 279.004 37.3136 278.793C40.8528 277.587 43.8014 276.571 20.4183 248.705C20.3107 248.576 20.1789 248.461 20.0596 248.343C18.8918 247.193 18.048 243.225 22.9319 235.063C29.3664 224.308 36.8734 201.725 39.5544 188.282C42.0612 175.713 47.3805 152.803 59.8952 140.648C61.022 139.553 62.8142 140.292 62.9486 141.857C64.1684 156.064 65.6357 186.872 63.6994 221.346C63.6892 221.527 63.6571 221.698 63.5991 221.87C58.6162 236.624 50.1045 272.361 55.0004 300.085C55.0673 300.464 55.2447 300.805 55.49 301.101C58.6619 304.936 64.7185 317.589 66.365 341.528C68.5072 372.678 69.5796 353.941 66.3765 397.293C66.3691 397.393 66.3682 397.493 66.3761 397.593C67.106 407.036 71.4642 433.091 82.9875 463.05C85.8473 468.786 89.851 482.838 82.9875 493.162C76.7477 502.547 75.9443 509.089 76.387 511.816C76.462 512.278 76.764 512.655 77.1722 512.883C81.3264 515.203 92.0144 519.086 107.013 518.999C107.998 518.993 108.82 518.251 108.935 517.273C110.014 508.064 111.541 488.186 110.334 470.04C108.726 445.843 113.015 383.469 110.334 362.499C108.429 347.594 115.655 308.101 120.925 284.141C121.378 282.081 124.222 282.08 124.681 284.138C130.024 308.098 137.571 347.594 135.666 362.499C132.985 383.469 137.274 445.843 135.666 470.04C134.459 488.186 135.986 508.064 137.065 517.273C137.18 518.251 138.002 518.993 138.987 518.999C153.986 519.086 164.674 515.203 168.828 512.883C169.236 512.655 169.538 512.278 169.613 511.816C170.056 509.089 169.252 502.547 163.012 493.162C156.149 482.838 160.153 468.786 163.012 463.05C174.536 433.091 178.876 407.036 179.624 397.593C179.632 397.493 179.631 397.393 179.623 397.293C176.42 353.941 177.493 372.678 179.635 341.528C181.281 317.589 187.338 304.936 190.51 301.101C190.755 300.805 190.933 300.464 191 300.085C195.896 272.361 187.384 236.624 182.401 221.87C182.343 221.698 182.311 221.527 182.301 221.346C180.364 186.872 181.832 156.064 183.051 141.857C183.186 140.292 184.978 139.553 186.105 140.648C198.62 152.803 203.939 175.713 206.446 188.282C209.127 201.725 216.634 224.308 223.068 235.063C227.952 243.225 227.108 247.193 225.94 248.343C225.821 248.461 225.689 248.576 225.582 248.705C202.199 276.571 205.147 277.587 208.686 278.793C209.304 279.004 210.02 278.932 210.578 278.593C234.98 263.774 225.783 280.628 216.841 290.751C216.703 290.907 216.579 291.102 216.504 291.296C213.059 300.26 242.401 286.158 243.946 280.904C243.974 280.808 243.995 280.729 244.029 280.634C253.55 254.263 225.741 151.129 220.923 120.531C217.063 96.0117 194.291 87.3725 183.389 86.1179C159.635 83.6106 147.127 74.9914 144.947 67.4244C144.824 66.9976 144.889 66.5411 145.08 66.1403Z"
                fill="#F4D79F"
              />
              {positions && (
                <>
                  {Object.entries(positions).map(([id, { cx, cy }]) => (
                    <circle
                      key={id}
                      id={id}
                      cx={cx}
                      cy={cy}
                      r="5"
                      fill={flagMap[id] ? "red" : ""}
                    />
                  ))}
                </>
              )}
            </svg>
          </Grid>
        </Grid>

        {/* CVP */}
        <Button
          variant="contained"
          // color="info"
          onClick={() => populateTable("CVP")}
          sx={
            CVP
              ? {
                position: "absolute",
                top: { lg: "1%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="CVP"
        >
          CVP
        </Button>
        {/* ETT */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => populateTable("ETT")}
          sx={
            ETT
              ? {
                position: "absolute",
                top: { lg: "1%", md: "8%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="ETT"
        >
          ENDOTRACHEAL TUBE
        </Button>
        {/* RT */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("RT");
          }}
          sx={
            RT
              ? {
                position: "absolute",
                top: { lg: "5%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="RT"
        >
          RT
        </Button>
        {/* rhIntracath */}
        <Button
          variant="contained"
          // color="info"
          onClick={() => {
            populateTable("rhIntracath");
          }}
          sx={
            rhIntracath
              ? {
                position: "absolute",
                top: { lg: "13%", md: "32%" },
                left: { lg: "30%", md: "22%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="rhIntracath"
        >
          rhIntracath
        </Button>
        {/* lhIntracath */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("lhIntracath");
          }}
          sx={
            lhIntracath
              ? {
                position: "absolute",
                top: { lg: "17%", md: "32%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="lhIntracath"
        >
          lhIntracath
        </Button>
        {/* cathater */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("cathater");
          }}
          sx={
            cathater
              ? {
                position: "absolute",
                top: { lg: "21%", md: "48%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="cathater"
        >
          cathater
        </Button>
        {/* rlIntracath */}
        <Button
          variant="contained"
          // color="info"
          onClick={() => {
            populateTable("rlIntracath");
          }}
          sx={
            rlIntracath
              ? {
                position: "absolute",
                top: { lg: "23%", md: "52%" },
                left: { lg: "30%", md: "22%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="rlIntracath"
        >
          rlIntracath
        </Button>
        {/* llIntracath */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("llIntracath");
          }}
          sx={
            llIntracath
              ? {
                position: "absolute",
                top: { lg: "25%", md: "55%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          // className={ CVP ? 'absolute top-[2.7rem] left-[2.5rem] border w-[1rem] h-fit border-orange-500 font-bold text-center rounded px-3 text-yellow-500':'hidden'}
          id="llIntracath"
        >
          llIntracath
        </Button>
        {/* epidural */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("epidural");
          }}
          sx={
            epidural
              ? {
                position: "absolute",
                top: { lg: "5%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="epidural"
        >
          Epidural
        </Button>
        {/* drain */}
        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("drain");
          }}
          sx={
            drain
              ? {
                position: "absolute",
                top: { lg: "9%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="drain"
        >
          Drain
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("icd");
          }}
          sx={
            icd
              ? {
                position: "absolute",
                top: { lg: "17%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="icd"
        >
          ICD
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("hdActh");
          }}
          sx={
            hdActh
              ? {
                position: "absolute",
                top: { lg: "21%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="hdActh"
        >
          HD Cath
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("cvpFemora");
          }}
          sx={
            cvpFemora
              ? {
                position: "absolute",
                top: { lg: "25%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="cvpFemora"
        >
          CVP Femoral
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("cvpUmbilical");
          }}
          sx={
            cvpUmbilical
              ? {
                position: "absolute",
                top: { lg: "29%", md: "8%" },
                left: { lg: "30%", md: "30%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="cvpUmbilical"
        >
          CVP Umbilical
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("plccLinne");
          }}
          sx={
            plccLinne
              ? {
                position: "absolute",
                top: { lg: "9%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="plccLinne"
        >
          PICC Line
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("thracheostomy");
          }}
          sx={
            thracheostomy
              ? {
                position: "absolute",
                top: { lg: "13%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="thracheostomy"
        >
          Tracheostomy
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("permacath");
          }}
          sx={
            permacath
              ? {
                position: "absolute",
                top: { lg: "23%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="permacath"
        >
          Perma Cath
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("chemoPort");
          }}
          sx={
            chemoPort
              ? {
                position: "absolute",
                top: { lg: "29%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="chemoPort"
        >
          Chemo Poprt
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("arterialLine");
          }}
          sx={
            arterialLine
              ? {
                position: "absolute",
                top: { lg: "27%", md: "15%" },
                left: { lg: "30%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="arterialLine"
        >
          Arterial Lines
        </Button>

        <Button
          variant="contained"
          // color="secondary"
          onClick={() => {
            populateTable("jejunostomy");
          }}
          sx={
            jejunostomy
              ? {
                position: "absolute",
                top: { lg: "27%", md: "15%" },
                right: { lg: "10%", md: "5%" },
              }
              : {
                visibility: "hidden",
              }
          }
          id="jejunostomy"
        >
          Jejunostomy
        </Button>

        {showArrows ? (
          <>
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["bottom"]}
              path="straight"
              start="CVPBOX"
              end="CVP"
              showXarrow={CVP}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["bottom"]}
              path="straight"
              start="ETTBOX"
              end="ETT"
              showXarrow={ETT}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["left"]}
              path="straight"
              start="RTBOX"
              end="RT"
              showXarrow={RT}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["top"]}
              path="straight"
              start="rhIntracathBOX"
              end="rhIntracath"
              showXarrow={rhIntracath}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["top"]}
              path="straight"
              start="lhIntracathBOX"
              end="lhIntracath"
              showXarrow={lhIntracath}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["top"]}
              path="straight"
              start="cathaterBOX"
              end="cathater"
              showXarrow={cathater}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["right"]}
              path="straight"
              start="rlIntracathBOX"
              end="rlIntracath"
              showXarrow={rlIntracath}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["left"]}
              path="straight"
              start="llIntracathBOX"
              end="llIntracath"
              showXarrow={llIntracath}
              strokeWidth={1}
              color="black"
              headSize={6}
            />
            {/* <Xarrow
              showHead={false}
              showTail={true}
              endAnchor={["left"]}
              path="straight"
              start="drain"
              end="drain"
              showXarrow={llIntracath}
              strokeWidth={1}
              color="black"
              headSize={6}
            /> */}
          </>
        ) : (
          ""
        )}

        <div className="w-full">
          {/* {data && data.length > 0 ? (
            <HumanBodyTable data={data} />
          ) : (
            <h3 className="flex justify-center my-5   font-bold text-gray-600">
              No Records Found...
            </h3>
          )} */}

          {spinner ? (
            <div className="grid justify-center">
              <LoadingSpinner />
            </div>
          ) : null}

          {dataResult.length > 0 && spinner === false ? (
            <CommonDynamicTableNew
              dataResult={dataResult}
              tableClass={"rounded"}
              // handleSelectedRow={handleSelectedRow}
              highlightRow={false}
              removeHeaders={[
                "id",
                "visitId",
                "patientVisitId",
                "Appointment Id",
                "doctorId",
                "Department Id",
                "UHID",
                "patientCategoryId",
                "Id",
              ]}
              renderActions={renderActions}
            />
          ) : (
            <h1 className="flex justify-center my-5 font-bold text-gray-600">
              No Records Found...
            </h1>
          )}
        </div>
      </div>
      {/* </fieldset> */}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: { lg: "30%", md: "60%" },
            maxWidth: "30%",
            height: "auto",
            minHeight: "30%",
            bgcolor: "background.paper",
            overflow: "visible",
            borderRadius: "0.7rem",
            boxShadow: 24,
            paddingX: 4,
            paddingBottom: 1,
          }}
          className=""
        >
          <div className="">
            <div className="flex py-2 mt-3 mb-1 justfy-between w-full mx-auto">
              <div className="w-full flex ">
                <h1 className="text-sm font-semibold mr-2">
                  {bodyInput.inputType}
                </h1>
              </div>
              <CancelPresentationIconButton
                onClick={() => {
                  handleClose();
                  fnReset();
                }}
              />
            </div>

            <hr className="border border-t-[1px] border-customBlue" />
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={1} className="w-full mx-auto mt-3">
                <Grid item lg={6} md={6} sx={{ marginTop: "0.6rem" }}>
                  {/*<LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Date"
                      name="date"
                      value={date}
                      inputProps={{ readOnly: true }}
                      onChange={(newValue) => {
                        setDate(newValue);
                      }}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField
                          className="bg-white"
                          fullWidth
                          size="small"
                          {...params}
                          sx={{
                            svg: {
                              color: "#0B83A5",
                              height: 22,
                              width: "100%",
                              marginRight: "16px",
                            },
                            backgroundColor: "white",
                            overflow: "visible",

                            "& .MuiOutlinedInput-root": {
                              "& .MuiOutlinedInput-input": {
                                // border: 0,
                                fontSize: 14,
                                height: "18px",
                                width: "100%",

                                borderColor: " ",
                                overflow: "hidden",
                              },
                              "& .MuiFormLabel-root": {
                                fontSize: "14px",
                              },
                            },
                          }}
                        />
                      )}
                    />
                        </LocalizationProvider>*/}
                  <DatePickerFieldNew
                    control={control}
                    name="date"
                    label="Date"
                    value={date}
                    inputFormat="dd-MM-yyyy"
                    inputRef={{
                      ...register("date", {
                        onChange: (e) => {
                          setDate(e.target.value);
                        },
                      }),
                    }}
                  />
                </Grid>

                <Grid item lg={6} md={6} sx={{ marginTop: "0.6rem" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopTimePicker
                      label=" Time"
                      name="time"
                      value={time}
                      inputProps={{ readOnly: true }}
                      onChange={(newValue) => {
                        setTime(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="bg-white"
                          fullWidth
                          size="small"
                          {...params}
                          sx={{
                            svg: {
                              color: "#0B83A5",
                              height: 22,
                              width: "100%",
                              marginRight: "16px",
                            },
                            backgroundColor: "white",
                            overflow: "visible",

                            "& .MuiOutlinedInput-root": {
                              "& .MuiOutlinedInput-input": {
                                // border: 0,
                                fontSize: 14,
                                height: "18px",
                                width: "100%",

                                borderColor: " ",
                                overflow: "hidden",
                              },
                              "& .MuiFormLabel-root": {
                                fontSize: "14px",
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={12} md={12} sx={{ marginY: "0.6rem" }}>
                  <InputField
                    control={control}
                    error={errors.doneBy}
                    name="doneBy"
                    label={bodyInput.applied ? "Inserted By *" : "Removed By *"}
                  />
                </Grid>
                <Grid item lg={12} md={12}>
                  <InputField
                    name="remarks"
                    label="Remarks"
                    error={errors.remarks}
                    control={control}
                  />
                </Grid>
              </Grid>
              <div className="flex">
                <CheckBoxField
                  control={control}
                  name="outSide"
                  label="Outside"
                />

                {props.userActions.map((obj) => (
                  <>
                    {!obj.isAction && obj.action === "Create" ? (
                      <>
                        <div className="flex justify-end w-full my-4 space-x-4 mt-3 ">
                          <CommonButton
                            type="button"
                            className="border border-customRed text-customRed"
                            label="Reset"
                            onClick={fnReset}
                          />
                          {props?.patientInformation?.BedReleased &&
                            props?.selectedPatient?.BedReleased &&
                            bodyInput.applied === true ? null : (
                            <CommonButton
                              type="submit"
                              className=" bg-customGreen text-white"
                              label="Save"
                              onClick={() => {
                                props.setPrivilege(obj.action);
                              }}
                            />
                          )}
                        </div>
                      </>
                    ) : null}
                  </>
                ))}
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      <CommonBackDrop
        openBackdrop={openBackdrop}
        setOpenBackdrop={setOpenBackdrop}
      />
      <ConfirmationModal
        confirmationOpen={deleteconfirm}
        confirmationHandleClose={handleCloseDeleteConfirm}
        confirmationSubmitFunc={deleteRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to delete this record ?"
        confirmationButtonMsg="Delete"
      />
      {modalType === "bedSore" &&<BedSoreAuditModel getpatientVisitId={getpatientVisitId} open={openModal}  handleClose={handleCloseModal}/>}
            {modalType === "equipment" &&<LinesModel getpatientVisitId={getpatientVisitId} open={openModal}  handleClose={handleCloseModal}/>}

    </>
  );
}
